"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWorkspace = void 0;
const preferencesReducer_1 = require("../preferencesReducer");
const getPreferencesByWorkspace_1 = require("../utilities/getPreferencesByWorkspace");
const initWorkspace_1 = require("../utilities/initWorkspace");
function setWorkspace(draft, action) {
    if (action.payload.workspaceSource === 'any') {
        const workspaceKey = action.payload.workspace;
        if (!draft.workspaces[workspaceKey]) {
            draft.workspaces[workspaceKey] = (0, getPreferencesByWorkspace_1.getPreferencesByWorkspace)(workspaceKey, draft.originalWorkspaces);
        }
        draft.workspace.current = workspaceKey;
    }
    else if (action.payload.workspaceSource === 'nmriumFile') {
        const workspaceData = { label: 'NMRium File', source: 'nmriumFile' };
        draft.workspaces[preferencesReducer_1.WORKSPACES_KEYS.nmriumKey] = (0, initWorkspace_1.initWorkspace)(action.payload.data, workspaceData);
        draft.originalWorkspaces[preferencesReducer_1.WORKSPACES_KEYS.nmriumKey] = (0, initWorkspace_1.initWorkspace)(action.payload.data, workspaceData);
        draft.workspace.current = preferencesReducer_1.WORKSPACES_KEYS.nmriumKey;
    }
}
exports.setWorkspace = setWorkspace;
